import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import Logo from "../../../shared/assets/logistics.png";
import { useTranslation } from "react-i18next";
import Language from "../../shared/pages/Language";
import { apiPost } from "../../../utils/apiHelpers";
import { fetchSystemConfig, readCachedSystemConfig } from "../../../shared/lib/systemConfig";
import "../../../shared/styles/Admin.css";

const { Title, Text } = Typography;

const Admin = () => {
  const [loading, setLoading] = useState(false);
  const [systemConfig, setSystemConfig] = useState(() => readCachedSystemConfig());
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    fetchSystemConfig().then(setSystemConfig).catch(() => null);
  }, []);

  const handleLogin = async (values) => {
    try {
      setLoading(true);
      const response = await apiPost("login", { email: values.email, password: values.password });
      const token = response?.data?.token;
      const user = response?.data?.user;
      const permissions = response?.data?.permissions;
      if (token) {
        localStorage.setItem("sessionToken", token);
        if (user) localStorage.setItem("sessionUser", JSON.stringify(user));
        if (permissions) localStorage.setItem("sessionPermissions", JSON.stringify(permissions));
        window.location.href = "/";
      } else {
        setLoading(false);
        message.error(t("invalid_credentials"));
      }
    } catch (error) {
      setLoading(false);
      const status = error?.response?.status;
      if (status === 422 || status === 401) message.error(t("invalid_credentials"));
      else if (error.request) message.error(t("no_response_error"));
      else message.error(t("login_failed"));
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-lang"><Language /></div>
      <div className="admin-login-center">
        <div className="admin-login-card-wrap">
          <div className="admin-login-logo-wrap">
            <img src={systemConfig?.login_logo_url || Logo} alt={systemConfig?.site_name || "Logo"} className="admin-login-logo" />
          </div>
          <div className="admin-login-card">
            <div className="admin-login-card-top-bar" />
            <Title level={4} className="admin-login-title">{systemConfig?.site_name || t("admin_login")}</Title>
            <Text type="secondary" className="admin-login-subtitle">{t("admin_login_subtitle")}</Text>
            <Form form={form} layout="vertical" onFinish={handleLogin} style={{ marginTop: 24 }} requiredMark={false}>
              <Form.Item name="email" rules={[{ required: true, message: t("fields_required") }, { type: "email", message: t("invalidEmail") }]}>
                <Input prefix={<MailOutlined className="admin-input-icon" />} placeholder={t("enterEmail")} size="large" className="admin-login-input" autoComplete="email" disabled={loading} />
              </Form.Item>
              <Form.Item name="password" rules={[{ required: true, message: t("fields_required") }]}>
                <Input.Password prefix={<LockOutlined className="admin-input-icon" />} placeholder={t("enterPassword")} size="large" className="admin-login-input" autoComplete="current-password" disabled={loading} />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button type="primary" htmlType="submit" size="large" loading={loading} block className="admin-login-btn">
                  {loading ? t("logging_in") : t("login")}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
